import React, { useEffect } from "react";
import { animateScroll } from "react-scroll";
import { getAppName } from "../helpers/mappingHelper";
import PropTypes from "prop-types";

const Log = ({ onClearLog, messages }) => {
  useEffect(() => {
    animateScroll.scrollToBottom({
      containerId: "log-list-container",
    });
  }, [messages]);

  const clearLog = () => {
    onClearLog();
  };

  const renderListItem = (message) => {
    return (
      <li
        style={{ color: message.color }}
        key={`${message.timeStamp} - ${message.text}`}
        className="list-group-item"
      >
        {message.timeStamp}: {getAppName(message.app)} - {message.text}
      </li>
    );
  };

  return (
    <div className="card" style={{ marginBottom: "24px" }}>
      <div className="card-body">
        <h3 className="card-title">Log</h3>
        <div className="card-text">
          <input
            type="button"
            value="Clear Log"
            id="clear_log"
            style={{ marginBottom: "10px" }}
            className="btn btn-primary"
            onClick={clearLog}
          />
          <div
            className="card"
            style={{ maxHeight: "643px", overflowY: "scroll" }}
            id="log-list-container"
          >
            <ul className="list-group list-group-flush" id="log-list">
              {messages.map((message) => {
                return renderListItem(message);
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

Log.propTypes = {
  onClearLog: PropTypes.func.isRequired,
  messages: PropTypes.array.isRequired,
};

export default Log;
